module.exports = __webpack_public_path__ + "static/media/responsibility-big2.b9f39cd1.jpg";